<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      v-if="rows"
      :search-options="{
        enabled: true,
        skipDiacritics: true,
      }"
      :sort-options="{
        enabled: false,
      }"
      :pagination-options="{
        enabled: true,
        perPage: 30,
      }"
    />
  </div>
</template>

<script>
import { DateTime } from "luxon";
export default {
  data: function() {
    return {
      columns: [
        {
          label: "Ticket ID",
          field: "ticketId",
        },
        {
          label: "Ticket name",
          field: "ticketName",
        },
        {
          label: "Appointment time (Pacific)",
          field: "datetimePacific",
        },
        {
          label: "Rep name",
          field: "repName",
        },
        {
          label: "User name",
          field: "userName",
        },
        {
          label: "Record created (Pacific)",
          field: "datetimeCreatedPacific",
        },
      ],
      bookings: null,
      loading: null,
    };
  },

  methods: {
    getBookings: async function() {
      try {
        this.loading = true;

        const response = await this.$axios({
          method: "get",
          url: `https://storage.googleapis.com/superior-press-tac.appspot.com/booking_reports/${
            this.apidata.system.system_id
          }.json?random=${Math.floor(Math.random() * 10000000)}`,
        });

        this.bookings = response.data.bookings;
      } catch (error) {
        this.$toast.error(error.message);
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  created: function() {
    this.getBookings();
  },

  computed: {
    rows: function() {
      if (this.bookings) {
        return this.bookings.map((booking) => {
          return {
            ticketId: booking.ticket?.id,
            ticketName: booking.ticket?.properties.subject,
            datetimePacific: DateTime.fromMillis(booking.booking.from, {
              zone: "America/Los_Angeles",
            }).toLocaleString(DateTime.DATETIME_FULL),
            repName: `${booking.rep?.properties.firstname ?? ""} ${booking.rep
              ?.properties.lastname ?? ""}`,
            userName: `${booking.user?.properties.firstname ?? ""} ${booking
              .user?.properties.lastname ?? ""}`,
            datetimeCreatedPacific: booking.booking.created
              ? DateTime.fromMillis(booking.booking.created, {
                  zone: "America/Los_Angeles",
                }).toLocaleString(DateTime.DATETIME_FULL)
              : "",
          };
        });
      } else {
        return null;
      }
    },
  },

  props: ["embed"],
};
</script>
